import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';

import css from './GalleryItem.module.scss';

class LogoBlock extends React.PureComponent {
    static propTypes = {
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        downloadImages: PropTypes.arrayOf(PropTypes.shape({
            url: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        }))
    }

    render() {
        const {
            name,
            description,
            text,
            image,
            downloadImages,
        } = this.props;

        return (
            <div className={css.item}>
                <div className={css.image}>
                    <img src={image} alt={name ? name : ''} />
                </div>
                <div className={css.info}>
                    <h3 className={css.name}>{name}</h3>
                    {description && <p className={css.description}>{description}</p>}
                    {text && <p className={css.text}>{text}</p>}
                </div>
                <div className={css.buttons}>
                    {downloadImages.map((item, index) => (
                        <Button
                            key={"button-"+index}
                            href={item.url}
                            block
                            secondary
                            download
                            target="_blank"
                        >
                            {item.label}
                        </Button>
                    ))}
                </div>
            </div>
        );
    }
}

export default LogoBlock;



// WEBPACK FOOTER //
// ./src/components/GalleryItem/GalleryItem.jsx